import React from 'react';
import PropTypes from 'prop-types';

import aiCreditsBannerImg from '../../assets/aiCreditsBannerImg.png';

const AiCreditsBanner = ({
    credits,
    freeScratchAssetGenerationsUsed,
    freeScratchBackdropsUsed,
    freeScratchProjectsUsed,
    freeScratchSoapNotesUsed,
    onBuyCredits,
    onClose
}) => {

    console.log(
        '[AI CREDITS] freeScratchProjectsUsed:',
        freeScratchProjectsUsed
    );

    const freeCharacterCostumeRemaining = Math.max(
        0,
        2 - freeScratchAssetGenerationsUsed
    );

    const freeBackdropsRemaining = Math.max(
        0,
        1 - freeScratchBackdropsUsed
    );

    const freeTherapyProjectsRemaining = Math.max(
        0,
        2 - freeScratchProjectsUsed
    );

    const freeSoapNotesRemaining = Math.max(
    0,
    3 - freeScratchSoapNotesUsed
);

      console.log(
        '[AI CREDITS] freeTherapyProjectsRemaining:',
        freeTherapyProjectsRemaining
    );

   return (
    <div style={styles.wrapper}>
        <button
            type="button"
            style={styles.closeButton}
            onClick={onClose}
            aria-label="Close AI credits"
            title="Close"
        >
            ×
        </button>

        <div style={styles.imageWrapper}>
            <img
                src={aiCreditsBannerImg}
                alt="Alyd Market AI creative tools"
                style={styles.image}
            />
        </div>

        <div style={styles.controls}>
            {/* Character + Costume free allowance */}
            <div style={styles.freeBalance}>
                <div style={styles.freeIcon}>
                    🎁
                </div>

                <div>
                    <div style={styles.freeNumber}>
                        {freeCharacterCostumeRemaining} / 2
                    </div>

                    <div style={styles.freeLabel}>
                        Character + Costume Free Remaining
                    </div>
                </div>
            </div>

            {/* Backdrop free allowance */}
            <div style={styles.freeBalance}>
                <div style={styles.freeIcon}>
                    🌄
                </div>

                <div>
                    <div style={styles.freeNumber}>
                        {freeBackdropsRemaining} / 1
                    </div>

                    <div style={styles.freeLabel}>
                        Backdrop Free Remaining
                    </div>
                </div>
            </div>

            {/* Therapy Project free allowance */}
            <div style={styles.freeBalance}>
                <div style={styles.freeIcon}>
                    🧩
                </div>

                <div>
                    <div style={styles.freeNumber}>
                        {freeTherapyProjectsRemaining} / 2
                    </div>

                    <div style={styles.freeLabel}>
                        Therapy Project Free Remaining
                    </div>
                </div>
            </div>

            {/* SOAP Note free allowance */}
            <div style={styles.freeBalance}>
                <div style={styles.freeIcon}>
                    📝
                </div>

                <div>
                    <div style={styles.freeNumber}>
                        {freeSoapNotesRemaining} / 3
                    </div>

                    <div style={styles.freeLabel}>
                        SOAP Note Free Remaining
                    </div>
                </div>
            </div>

            {/* Paid AI Credits */}
            <div style={styles.creditBalance}>
                <div style={styles.creditIcon}>
                    ✨
                </div>

                <div>
                    <div style={styles.creditNumber}>
                        {credits}
                    </div>

                    <div style={styles.creditLabel}>
                        AI {credits === 1 ? 'Credit' : 'Credits'}
                    </div>
                </div>
            </div>

            <button
                type="button"
                style={styles.buyButton}
                onClick={onBuyCredits}
            >
                Buy AI Credits
            </button>
        </div>
    </div>
);
};

AiCreditsBanner.propTypes = {
    credits: PropTypes.number,
    freeScratchAssetGenerationsUsed: PropTypes.number,
    freeScratchSoapNotesUsed: PropTypes.number,
    freeScratchBackdropsUsed: PropTypes.number,
    freeScratchProjectsUsed: PropTypes.number,
    onBuyCredits: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

AiCreditsBanner.defaultProps = {
    credits: 0,
    freeScratchAssetGenerationsUsed: 0,
    freeScratchBackdropsUsed: 0,
    freeScratchProjectsUsed: 0,
    freeScratchSoapNotesUsed: 0
};

const styles = {
    wrapper: {
        position: 'relative',
        width: '100%',
        maxWidth: '1500px',
        margin: '0 auto',
        padding: '8px 18px 12px',
        boxSizing: 'border-box'
    },

    imageWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },

    image: {
        display: 'block',
        width: '100%',
        maxWidth: '1400px',
        height: 'auto',
        objectFit: 'contain'
    },

    controls: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px',
        maxWidth: '1400px',
        margin: '2px auto 0',
        paddingRight: '18px',
        boxSizing: 'border-box'
    },

    freeBalance: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        minHeight: '38px',
        padding: '6px 14px',
        border: '1px solid #ddd3ff',
        borderRadius: '10px',
        background: '#f8f6ff',
        boxSizing: 'border-box'
    },

    freeIcon: {
        fontSize: '18px',
        lineHeight: 1
    },

    freeNumber: {
        color: '#5b21b6',
        fontSize: '16px',
        lineHeight: 1,
        fontWeight: '800'
    },

    freeLabel: {
        marginTop: '3px',
        color: '#756f86',
        fontSize: '10px',
        lineHeight: 1,
        fontWeight: '700'
    },

    creditBalance: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        minHeight: '38px',
        padding: '6px 14px',
        border: '1px solid #dbeafe',
        borderRadius: '10px',
        background: '#f8fbff',
        boxSizing: 'border-box'
    },

    creditIcon: {
        fontSize: '18px',
        lineHeight: 1
    },

    creditNumber: {
        color: '#082f73',
        fontSize: '16px',
        lineHeight: 1,
        fontWeight: '800'
    },

    creditLabel: {
        marginTop: '3px',
        color: '#64748b',
        fontSize: '10px',
        lineHeight: 1,
        fontWeight: '700'
    },

    buyButton: {
        minHeight: '38px',
        padding: '8px 18px',
        border: 'none',
        borderRadius: '10px',
        background: '#1976d2',
        color: '#ffffff',
        fontSize: '13px',
        fontWeight: '700',
        cursor: 'pointer',
        boxShadow: '0 3px 9px rgba(25, 118, 210, 0.20)'
    },

    closeButton: {
        position: 'absolute',
        top: '7px',
        right: '12px',
        zIndex: 2,
        width: '28px',
        height: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0,
        border: '1px solid #dbe3ec',
        borderRadius: '50%',
        background: '#ffffff',
        color: '#475569',
        fontSize: '19px',
        lineHeight: 1,
        fontWeight: '700',
        cursor: 'pointer',
        boxShadow: '0 2px 7px rgba(15, 23, 42, 0.12)'
    }
};

export default AiCreditsBanner;